import { render } from "./ImageMaskContainer.vue?vue&type=template&id=58517826&ts=true"
import script from "./ImageMaskContainer.vue?vue&type=script&lang=ts"
export * from "./ImageMaskContainer.vue?vue&type=script&lang=ts"

import "./ImageMaskContainer.vue?vue&type=style&index=0&id=58517826&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__